// @flow
const dataRaf = {
  title: __("seo.content.title_raf"),
  description: __("seo.content.description_raf"),
  image_og: "logo_refer_a_friend_og.png",
  image_twitter: "logo_refer_a_friend_twitter.png",
  social_url_path: "/{lang}/pages/invite",
}

const headerData = {
  about: {
    title: __("seo.content.title_about"),
    description: __("seo.content.description_about"),
    keywords: __("seo.content.keywords_about"),
  },
  account: {
    title: __("seo.content.title_account"),
    description: __("seo.content.description_account"),
    keywords: __("seo.content.keywords_account"),
  },
  business: {
    title: __("seo.content.title_business"),
    description: __("seo.content.description_business"),
    keywords: __("seo.content.keywords_business"),
  },
  company: {
    title: __("seo.content.title_company"),
    description: __("seo.content.description_company"),
    keywords: __("seo.content.keywords_company"),
  },
  cookies: {
    title: __("seo.content.title_cookies"),
    description: __("seo.content.description_cookies"),
    keywords: __("seo.content.keywords_cookies"),
  },
  cookies_settings: {
    title: __("seo.content.title_cookies_settings"),
    description: __("seo.content.description_cookies_settings"),
    keywords: __("seo.content.keywords_cookies_settings"),
  },
  mobile: {
    title: __("seo.content.title_mobile"),
    description: __("seo.content.description_mobile"),
    keywords: __("seo.content.keywords_mobile"),
  },
  faq: {
    title: __("seo.content.title_faq"),
    description: __("seo.content.description_faq"),
    keywords: __("seo.content.keywords_faq"),
  },
  feedback: {
    title: __("seo.content.title_feedback"),
    description: __("seo.content.description_feedback"),
    keywords: __("seo.content.keywords_feedback"),
  },
  guarantee: {
    title: __("seo.content.title_guarantee"),
    description: __("seo.content.description_guarantee"),
    keywords: __("seo.content.keywords_guarantee"),
  },
  helpcenter: {
    title: __("seo.content.title_helpcenter"),
    description: __("seo.content.description_helpcenter"),
    keywords: __("seo.content.keywords_helpcenter"),
  },
  helpcenterarticle: {
    title: __("seo.content.title_helpcenterarticle"),
    description: __("seo.content.description_helpcenterarticle"),
    keywords: __("seo.content.keywords_helpcenterarticle"),
  },
  helpcenterarticlesearch: {
    title: __("seo.content.title_helpcenterarticlesearch"),
    description: __("seo.content.description_helpcenterarticlesearch"),
    keywords: __("seo.content.keywords_helpcenterarticlesearch"),
  },
  helpcentercategory: {
    title: __("seo.content.title_helpcentercategory"),
    description: __("seo.content.description_helpcentercategory"),
    keywords: __("seo.content.keywords_helpcentercategory"),
  },
  helpcentersearch: {
    title: __("seo.content.title_helpcentersearch"),
    description: __("seo.content.description_helpcentersearch"),
    keywords: __("seo.content.keywords_helpcentersearch"),
  },
  "introducing-new-brand": {
    title: __("seo.content.title_introducing-new-brand"),
    description: __("seo.content.description_introducing-new-brand"),
    keywords: __("seo.content.keywords_introducing-new-brand"),
  },
  investors: {
    title: __("seo.content.title_investors"),
    description: __("seo.content.description_investors"),
    keywords: __("seo.content.keywords_investors"),
  },
  legal: {
    title: __("seo.content.title_legal"),
    description: __("seo.content.description_legal"),
    keywords: __("seo.content.keywords_legal"),
  },
  media: {
    title: __("seo.content.title_media"),
    description: __("seo.content.description_media"),
    keywords: __("seo.content.keywords_media"),
  },
  partner: {
    title: __("seo.content.title_partner"),
    description: __("seo.content.description_partner"),
    keywords: __("seo.content.keywords_partner"),
  },
  people: {
    title: __("seo.content.title_people"),
    description: __("seo.content.description_people"),
    keywords: __("seo.content.keywords_people"),
  },
  privacy: {
    title: __("seo.content.title_privacy"),
    description: __("seo.content.description_privacy"),
    keywords: __("seo.content.keywords_privacy"),
  },
  "privacy-research": {
    title: __("seo.content.title_privacy_research"),
    description: __("seo.content.description_privacy_research"),
    keywords: __("seo.content.keywords_privacy_research"),
  },
  product: {
    title: __("seo.content.title_product"),
    description: __("seo.content.description_product"),
    keywords: __("seo.content.keywords_product"),
  },
  refund: {
    title: __("seo.content.title_refund"),
    description: __("seo.content.description_refund"),
    keywords: __("seo.content.keywords_refund"),
  },
  team: {
    title: __("seo.content.title_team"),
    description: __("seo.content.description_team"),
    keywords: __("seo.content.keywords_team"),
  },
  security: {
    title: __("seo.content.title_security"),
    description: __("seo.content.description_security"),
    keywords: __("seo.content.keywords_security"),
  },
  widgets: {
    title: __("seo.content.title_widgets"),
    description: __("seo.content.description_widgets"),
    keywords: __("seo.content.keywords_widgets"),
  },
  invite: dataRaf,
  invite_how: dataRaf,
  invite_register: dataRaf,
}

export type HeaderData = {
  title: string,
  description: string,
  keywords?: string,
  image_og?: string,
  image_twitter?: string,
  social_url_path?: string,
}

export type Page = $Keys<typeof headerData>

export default headerData
